import * as CL from '@design-system/component-library';
import { RecordInput } from './RecordInput.js';
import { validateHostname } from './fieldValidation.js';

export const NSValueField = ({ index }: { index: number }) => (
  <CL.GridCol colsXS={4}>
    <RecordInput name="value" validate={validateHostname} index={index} />
  </CL.GridCol>
);
